var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKeyboardArrowUp = function SvgKeyboardArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.478 14.89a.864.864 0 0 1-.267-.596.775.775 0 0 1 .242-.597l4.95-4.95a.862.862 0 0 1 .283-.196.83.83 0 0 1 .314-.059.83.83 0 0 1 .314.06c.097.039.191.104.283.195l4.95 4.925a.77.77 0 0 1 .255.59.812.812 0 0 1-.255.604.831.831 0 0 1-.61.255.831.831 0 0 1-.609-.255L12 10.563l-4.328 4.353a.715.715 0 0 1-.585.242.877.877 0 0 1-.609-.267"
  })));
};
export default SvgKeyboardArrowUp;